import { useGetAttachmentsByDocId } from "@/api/attachment";
import { Attachment } from "@/lib/types";
import { useMemo } from "react";

const defaultQuality = "mediumPublicUrl";

export type MediaAttachmentQuality = Extract<
  "mediumPublicUrl" | "largePublicUrl",
  keyof Attachment
>;

export function useMediaAttachment(
  imagePosition: string,
  docId?: string,
  quality: MediaAttachmentQuality = defaultQuality,
) {
  const { data: imageAttachments, refetch } = useGetAttachmentsByDocId(docId, {
    pollPosition: imagePosition,
  });

  const attachment = useMemo(() => {
    if (!imageAttachments) return undefined;
    return imageAttachments.find((a) => a.position === imagePosition);
  }, [imageAttachments, imagePosition]);

  const previewImageUrl = attachment?.[quality] || undefined;
  const videoPublicUrl = attachment?.videoPublicUrl ?? undefined;
  const embedUrl = attachment?.embedUrl ?? undefined;
  const mediaKind = attachment?.kind ?? "image";

  return {
    attachment,
    previewImageUrl,
    /** @deprecated use previewImageUrl */
    imageURL: previewImageUrl,
    videoPublicUrl,
    embedUrl,
    mediaKind,
    refetch,
  };
}

export default useMediaAttachment;
